import { Component } from "@angular/core";
import { CompanyDataService } from "../company-data.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Dictionary } from "src/app/store/models/common_types";
import { CompanyPageMeta } from "src/app/store/models/company-page-store.model";
import { SetCompanyPageMeta } from "src/app/store/actions/company-page.actions";
import { EarningsPreview } from "../company-page.model";
import * as GlobalSubheaderActions from "../../store/actions/global-subheader.actions";
import { Subscription } from "rxjs";
import { AppService } from "../../app.service";
import { CompanyEarningsPreviewComponent } from "../company-earnings-preview/company-earnings-preview.component";
import { UpdateRecentCompanies } from "src/app/store/actions/global-header.actions";
import { NzModalService } from "ng-zorro-antd/modal";
import { externalLink, VAIconRegistryService } from "@va/core-library/icons";
import { PharmaDataService } from "src/app/pharma-page/pharma-data.service";
@Component({
  selector: "app-company-page",
  templateUrl: "./company-page.component.html",
  styleUrls: ["./company-page.component.scss"],
  host: { class: "company-page-component" },
})
export class CompanyPageComponent {
  ticker: string;
  companyId: number;
  isTearSheetDownloadable: boolean;
  symbologycompanyid: number;
  metaReady = false;
  temp: any;
  showStatus = true;
  statusData = {};
  monitorMetaData = {};
  limMetaLoaded = false;
  companyFlag: number;
  reloadComponent: boolean;
  storeSub: Subscription;
  activityFeedObj: {
    companyId?: number;
    showAlertPopover: boolean;
    type: string;
    showWatchlist?: boolean;
  };
  earningsPreview: EarningsPreview;
  drugsCount: number;
  hasPharmaAccess = true;
  pharmaParms: {
    companyids: number[];
    columns: string[];
    period_basis: string;
    period_type: string;
    revenue_type: string;
  } = {
    companyids: [],
    columns: ["api", "moa", "target", "indications"],
    period_basis: "calendar",
    period_type: "absolute",
    revenue_type: "total_revenue",
  };

  constructor(
    private dataService: CompanyDataService,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private appService: AppService,
    private modalService: NzModalService,
    private iconRegistryService: VAIconRegistryService,
    private router: Router,
    private pharmaService: PharmaDataService,
  ) {
    this.iconRegistryService.registerIcons([externalLink]);
    this.reloadComponent = false;
  }
  ngOnInit() {
    this.route.params.subscribe((param) => {
      this.reloadComponent = false;
      this.metaReady = false;
      this.activityFeedObj = null;
      this.limMetaLoaded = false;
      this.monitorMetaData = {};
      this.ticker = decodeURIComponent(param.ticker);
      const extraData = {
        beginning_state_referrer: "",
      };
      this.appService.logUserAction(
        {},
        this.ticker,
        "",
        "COMPANY_PAGE",
        extraData,
        "",
        "",
      );
      this.store.dispatch(
        new GlobalSubheaderActions.TickerChanged(this.ticker),
      );
      this.dataService
        .getCompanyMeta(this.ticker)
        .subscribe((data: CompanyPageMeta) => {
          this.store.dispatch(
            new SetCompanyPageMeta({
              ticker: this.ticker,
              value: data,
            }),
          );
          if (data.status !== "error") {
            this.store.dispatch(new UpdateRecentCompanies(data));
          }
        });
      setTimeout(() => {
        this.reloadComponent = true;
      }, 10);

      // setTimeout(() => {
      //   if(this.companyId && this.drugsCount){
      //     this.pharmaParms.companyids.push(this.companyId);
      //     console.log("params",this.pharmaParms)
      //     this.pharmaService.getPharmaMexGridMeta(this.pharmaParms).subscribe((resp)=>{
      //       console.log("response",resp)
      //     });
      //   }
      // }, 1000);
      //monitor meta - used for Line Item monitor and earnings preview
      this.dataService.getLineItemMeta(this.ticker).subscribe(
        (res: any) => {
          const meta = res.data;
          this.limMetaLoaded = true;
          this.monitorMetaData = meta;
          if (meta) {
            // this.monitorMetaData["currentQuarter"] = meta.current_quarter
            //   ? meta.current_quarter
            //   : "";
            // this.monitorMetaData["filingsPeriod"] = meta.filings_period
            //   ? meta.filings_period
            //   : "";
            // this.monitorMetaData["currencyValue"] = meta.currency_value
            //   ? meta.currency_value
            //   : "";
            // this.monitorMetaData["firstEstimatedPeriod"] =
            //   meta.first_estimated_period;
            this.earningsPreview = {
              quarters: meta.quarters ? meta.quarters : [],
              periodRange: meta.period_range ? meta.period_range : {},
              periodDropdown: meta.period_values,
              showMonitoring: meta.entitled,
              currencyValue: meta.currency_value ? meta.currency_value : "",
            };
          }
        },
        () => {
          this.limMetaLoaded = true;
          // cant set monitorMetaData to null, because then lim-monitor component again makes call for loading meta
          // so setting status: error (same as what API should have set), and it invokes failure template of lim-monitor component.
          this.monitorMetaData = { status: "error" };
        },
      );
    });
    //this.ticker = decodeURIComponent(this.route.snapshot.params["ticker"]);

    this.storeSub = this.store
      .select(stateGetter("companyPage", "meta"))
      .subscribe((data: Dictionary<CompanyPageMeta>) => {
        if (data[this.ticker]) {
          const meta = data[this.ticker];
          this.isTearSheetDownloadable =
            meta.user_type === "MODELS_ONLY_INBOX" ? true : false;
          this.symbologycompanyid = meta.symbologycompanyid;
          this.companyId = meta.companyid;
          this.companyFlag = meta.company_flag;
          if (
            !this.activityFeedObj ||
            this.companyId !== this.activityFeedObj.companyId
          ) {
            this.activityFeedObj = {
              companyId: this.companyId,
              showAlertPopover: false,
              type: "all",
            };
          }
          if (meta["industryid"] === 103 || meta["industryid"] === 105) {
            const drugsCountParam = {
              ticker: this.ticker,
            };
            this.pharmaService
              .getDrugsCount(drugsCountParam)
              .subscribe((resp) => {
                this.drugsCount =
                  resp.drugs_count && resp.drugs_count > 0
                    ? resp.drugs_count
                    : 0;
                this.hasPharmaAccess = resp.pharma_access;
              });
          } else {
            this.drugsCount = 0;
            this.hasPharmaAccess = false;
          }
          this.metaReady = true;
        }
      });
  }
  redirectToPharma() {
    if (this.hasPharmaAccess) {
      // redirect to drug db
      this.pharmaService.logUserAction("REDIRECT_FROM_COMPANY", this.ticker);
      setTimeout(() => {
        window.open(
          `/biopharma/database/filter?company_id=${this.companyId}`,
          "_blank",
        );
      }, 100);
    } else {
      // redirect to external marketing page
      window.open("https://visiblealpha.com/biopharma-request-demo/", "_blank");
    }
  }
  sendEarningsPreview() {
    this.modalService.create({
      nzTitle: "Earnings Preview",
      nzContent: CompanyEarningsPreviewComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        ticker: this.ticker,
        quarters: this.earningsPreview.quarters,
        periodRange: this.earningsPreview.periodRange,
        periodDropdown: this.earningsPreview.periodDropdown,
        showMonitoring: this.earningsPreview.showMonitoring,
        currencyValue: this.earningsPreview.currencyValue,
      },
      nzWrapClassName: "earning-preview-modal vertical-center-modal",
      nzFooter: [
        {
          label: "Ok",
          show: false,
        },
      ],
    });
  }

  ngOnDestroy() {
    this.storeSub.unsubscribe();
  }
}
